module.exports = __webpack_public_path__ + "img/c081dc1.jpg";